import React, {Component} from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class AdCard extends Component {
	constructor () {
		super()
		this.state = {
			owner: "",
			title: "",
			location: "",
			category: "",
			price: "",
			link: "",
			createdAt: "",
		}
	}
	componentDidMount () {
		this.setState({
			owner: this.props.data.owner,
			title: this.props.data.title,
			location: this.props.data.location,
			category: this.props.data.category,
			price: this.props.data.price,
			link: this.props.data.link,
			createdAt: this.props.data.createdAt,
		})
	}
	render () {
		const adSubString = (this.state.title).substring(0,1).toUpperCase()
		const owner = this.state.owner
		const title = this.state.title
		const location = this.state.location
		const category = this.state.category
		const price = this.state.price
		const link = this.state.link
		const createdAt = this.state.createdAt
		return (
			<div>
				<Container>
					<Row className=".justify-content-md-center">
						<Col xs lg="12">
					      <div className="adCard">
					      		<Row>
					      			<Col md="3" xs="4" lg="2">
					      				<div className="iconLabel lightBlue">
					      					<span>{adSubString}</span>
					      				</div>
					      			</Col>

					      			<Col md="6" xs lg="6">
					      				<Row>
					      					<span className="owner lightGrey">{owner}</span>
					      				</Row>
					      				<Row>
					      					<span className="title darkGrey">{title}</span>
					      				</Row>
					      				<Row>
					      					<span className="location lightGrey">{location}</span>
					      				</Row>
					      				<Row>
						      				<div className="categorySection">
						      					<span className="categoryLabel">{category}</span>
						      					<a href={link} className=" blue">See item</a>
						      				</div>
					      				</Row>
					      			</Col>

					      			<Col md lg="4">
					      				<Row>
					      					<div className="sponsored right">&nbsp;</div>
					      				</Row>
					      				<Row>
					      					<div className="amount right blue">₦ {price}</div>
					      				</Row>
					      				<Row>
					      					<div className="location right">&nbsp;</div>
					      				</Row>
					      				<Row>
					      					<div className="minsAgo right lightGrey">{createdAt}</div>
					      				</Row>
					      			</Col>
					      		</Row>
					      </div>
					    </Col>
					  </Row>
				</Container>
			</div>
		)
	}
}

export default AdCard